import { Clock } from 'lucide-react';
import { useLaunchDarkly } from '@/providers/launchdarkly-provider';

export const ScheduledMaintenanceBanner = () => {
  const { scheduledMaintenanceBannerMessage } = useLaunchDarkly();

  const message = scheduledMaintenanceBannerMessage?.trim() || '';

  if (!message) {
    return null;
  }

  return (
    <div className='flex items-center justify-center gap-2.5 bg-blue-100 dark:bg-blue-950/40 px-4 py-2 border-b border-blue-300 dark:border-blue-800'>
      <Clock className='size-4 shrink-0 text-blue-700 dark:text-blue-500' />
      <span className='font-semibold text-sm text-blue-900 dark:text-blue-300'>
        {message}
      </span>
    </div>
  );
};
